/**
 * en-GB messages added by Phase 2 task S14 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s14EnGB = {
    'error.preregistration_required': 'This group needs a pre-registration, and none was found for this visitor.',
    'error.preregistration_not_found': 'That pre-registration cannot be used here.',
    'error.not_signed_in': 'This person is not signed in.',
    'visit.event.replaced_automatic': 'A real sign-out replaced the automatic one; the automatic sign-out stays in the history.',
    'visit.event.auto_signed_out': 'Signed out automatically at the set time.',
    'visit.event.assumed_in': 'Assumed in from the start of the day (sign-out-first group).',
    'visit.event.added_by_hand': 'Added by hand on the timesheet.',
};
//# sourceMappingURL=s14.js.map